var _excluded = ["node", "gap", "children"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/prop-types */
import React from 'react';
import useForceUpdate from "../../hooks/useForceUpdate";
import { jsx as _jsx } from "react/jsx-runtime";
var Nodify = function Nodify(Component) {
  var NodifiedHoc = function NodifiedHoc(_ref) {
    var node = _ref.node,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 10 : _ref$gap,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var forceUpdate = useForceUpdate();
    var useSignal = React.useCallback(function (signal, handler) {
      React.useEffect(function () {
        var listener = function listener(signalSended, data, origin) {
          if (signalSended === signal) {
            handler(data, origin);
          }
        };
        node.addSignalListener(listener);
        return function () {
          node.removeSignalListener(listener);
        };
      }, [node, signal, handler]);
    }, [node]);
    useSignal('metaUpdated', forceUpdate);
    useSignal('dataUpdated', forceUpdate);
    useSignal('childAdded', forceUpdate);
    useSignal('childRemoved', forceUpdate);
    var sendSignalToParent = React.useCallback(function (signal, data) {
      node.sendSignalToParent(signal, data);
    }, [node]);
    var sendSignalToChildren = React.useCallback(function (signal, data) {
      node.sendSignalToChildren(signal, data);
    }, [node]);
    var useMeta = React.useCallback(function (name, value) {
      return node.useMeta(name, value);
    }, [node]);
    var setData = React.useCallback(function (value) {
      // eslint-disable-next-line no-param-reassign
      node.data = value;
    }, [node]);
    var currentDeep = node.deep;
    return /*#__PURE__*/_jsx("div", {
      style: {
        marginLeft: currentDeep * gap + "px"
      },
      children: /*#__PURE__*/React.createElement.apply(React, [Component, Object.assign({}, rest, {
        node: node,
        data: node.data,
        setData: setData,
        hasChildren: node.hasChildren(),
        isRoot: node.isRoot(),
        useSignal: useSignal,
        sendSignalToParent: sendSignalToParent,
        sendSignalToChildren: sendSignalToChildren,
        useMeta: useMeta,
        deep: currentDeep,
        gap: gap
      })].concat(children))
    });
  };
  NodifiedHoc.handledProps = [];
  return NodifiedHoc;
};
Nodify.handledProps = [];
export default Nodify;